require('regenerator-runtime/runtime');
const createFFmpeg = require('./createFFmpeg');

module.exports = {
  createFFmpeg,
};
